import { GraphUtils } from '@helpers/graph.helper';
import { Sensor } from '../sensor/sensor';
import { Router } from '@angular/router';
import { UtilsHelper } from '@helpers/utils.helper';

export class WaterEcAttribute extends Sensor {
  public waterEcChart: any;
  private waterEcSensor: any[];
  public iconsToDisplay: { icon: string, type: number }[] = [];

  constructor(router: Router, url: string, alertsActive: boolean) {
    super(router, url, alertsActive);
    this.waterEcChart = null;
    this.waterEcSensor = [];
  }

  private ensureArraySize(arr: any[], position: number): void {
    while (arr.length <= position) {
      arr.push([]);
    }
  }

  public prepareData(): void {
    const iconMap = new Map<string, { icon: string, type: number }>();
    for (const element of this.data) {
      const date = new Date(element.date);
      const timestamp = GraphUtils.getDateUtc(date);
      const position = element.position;
      const sensorInfo = UtilsHelper.nameSensor(element.type);
      const icon = sensorInfo.icon;
      if (!iconMap.has(icon)) {
        iconMap.set(icon, {
          icon,
          type: element.type
        });
      }

      this.ensureArraySize(this.waterEcSensor, position);
      this.waterEcSensor[position].push([timestamp, element.waterEc]);
    }
    this.iconsToDisplay = Array.from(iconMap.values());
  }

  public setCharts(): void {
    const filteredWaterEc = this.waterEcSensor.filter(series => series.length > 0);

    const positionNodeWaterEc = this.waterEcSensor
      .map((item, index) => (item.length > 0 ? index + 1 : -1))
      .filter(index => index !== -1);

    this.waterEcChart = this.getConfigChar(
      'waterEc',
      this.getChartSeriesNewNode('Sensor', filteredWaterEc, positionNodeWaterEc),
      this.getRanges('waterEc'),
      this.getLimits('waterEc')
    );
  }

  public hasWaterEcSensor(pos: number): boolean {
    const index = pos - 1;
    return (
      index >= 0 &&
      index < this.waterEcSensor.length &&
      this.waterEcSensor[index].length > 0
    );
  }

  public getWaterEcSensor(pos: number): any {
    const index = pos - 1;
    if (index >= 0 && index < this.waterEcSensor.length) {
      const sensorData = this.waterEcSensor[index];
      if (sensorData.length > 0) {
        return sensorData[sensorData.length - 1][1] ?? null;
      }
    }
    return null;
  }

  public static getVariables(): any[] {
    return [
      { title: 'Conductividad Agua', value: 'waterEc' }
    ];
  }
}
